import { useState } from "react";
import * as React from "react";
import { Product } from "~/apps/pos/models";
import { DeleteConfirmOverlay } from "~/apps/pos/admin/components/shared/DeleteConfirmOverlay";
import { useDeleteProduct } from "~/apps/pos/apis/products";

export const useProductDeleteConfirm = () => {
  const [deleteItem, setDeleteItem] = useState<Product | undefined>(undefined);
  const { mutate: onDelete, isLoading, error } = useDeleteProduct();

  const handleClose = () => setDeleteItem(undefined);

  const handleDelete = () => {
    if (!deleteItem?.id) return;
    onDelete(deleteItem.id, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const deleteConfirm = deleteItem ? (
    <DeleteConfirmOverlay
      headTitle={"Delete product!"}
      itemName={deleteItem.name}
      isLoading={isLoading}
      error={error?.message || error?.errorMessage || ""}
      onClose={handleClose}
      onDelete={handleDelete}
    />
  ) : null;

  return {
    deleteConfirm,
    showDeleteConfirm: setDeleteItem,
  };
};
